import { render, staticRenderFns } from "./dokumen.vue?vue&type=template&id=597d718e"
import script from "./dokumen.vue?vue&type=script&lang=js"
export * from "./dokumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports